import { useState } from "react";
import { Send, Loader2, CheckCircle2, UserRound } from "lucide-react";
import { api, apiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { PhotoPicker } from "@/components/PhotoPicker";

export function ForwardForm({ question, t, id, done, onSent, initialPhotos }) {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState("");
  const [msg, setMsg] = useState(question);
  const [state, setState] = useState(done ? "sent" : "idle");
  const [err, setErr] = useState("");
  const [photos, setPhotos] = useState(initialPhotos || []);
  const [uploading, setUploading] = useState(false);

  if (state === "sent") return <div className="ask-sent fwd-sent" data-testid={`help-forward-sent-${id}`}><CheckCircle2 size={16} />{email ? t("Sent! You'll get a reply at {e}.", { e: email }) : t("Sent to the developer")}</div>;
  if (!open) return (
    <button type="button" className="go-btn" data-testid={`help-forward-${id}`} onClick={() => { setEmail(user?.email || ""); setOpen(true); }}>
      <UserRound size={14} />{t("Send to the developer")}
    </button>
  );

  const submit = async (e) => {
    e.preventDefault(); setState("busy"); setErr("");
    try { await api.ask({ email, name: user?.name || "", message: `[Helper] ${msg}`, photo_ids: photos.map((p) => p.id) }); setState("sent"); onSent?.(); window.dispatchEvent(new Event("questions-changed")); }
    catch (e2) { setErr(apiError(e2) || t("Something went wrong. Try again.")); setState("idle"); }
  };

  return (
    <form className="fwd-form" onSubmit={submit} data-testid={`help-forward-form-${id}`}>
      <textarea className="text-input ask-text fwd-text" data-testid={`help-forward-message-${id}`} required minLength={3} maxLength={1900}
        value={msg} onChange={(e) => setMsg(e.target.value)} />
      <input className="text-input" data-testid={`help-forward-email-${id}`} type="email" required placeholder={t("Your email")}
        value={email} onChange={(e) => setEmail(e.target.value)} />
      <PhotoPicker photos={photos} setPhotos={setPhotos} setUploading={setUploading} t={t} testid={`help-forward-${id}`} />
      {err && <div className="form-error" data-testid={`help-forward-error-${id}`}>{err}</div>}
      <div className="action-row">
        <button type="button" className="ghost-btn inbox-btn" data-testid={`help-forward-cancel-${id}`} onClick={() => setOpen(false)}>{t("Cancel")}</button>
        <button type="submit" className="primary-btn primary-btn-small" data-testid={`help-forward-send-${id}`} disabled={state === "busy" || uploading}>
          {state === "busy" ? <Loader2 size={16} className="spin" /> : <Send size={16} />}{t("Send")}
        </button>
      </div>
    </form>
  );
}
